import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SLICE_BASE_NAME } from './constants'
import {setSessionData} from "@/features/context/SessionContext";

export interface SessionState {
    signedIn: boolean
    token: string | null
}

const initialState: SessionState = {
    signedIn: false,
    token: null,
}

const sessionSlice = createSlice({
    name: `${SLICE_BASE_NAME}/session`,
    initialState,
    reducers: {
        loginSuccess(state, action: PayloadAction<any>) {
            if (action.payload?.token) {
                setSessionData('token', action.payload?.token)
                state.token = action.payload?.token
            }
            state.signedIn = true
        },
        signOutSuccess(state) {
            state.signedIn = false
            state.token = null
            setSessionData('token', null)
        },
    },
})

export const { loginSuccess, signOutSuccess } = sessionSlice.actions
export default sessionSlice.reducer
